import { ContentHeaderButton } from "../../contentHeaderButton";
import { IndorImages, getIndorImageSrc } from "../../../../features";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { controlPathNormativitiesInfoFilterButton, controlSearchLineButton } from "./widgetsFunctions";

const dateFilterButtonIconSrc = require('../../../../assets/images/icons/date_filter_icon.svg').default

const searchLineButtonIconSrc = getIndorImageSrc(IndorImages.MapNavigateZoom);

export default function ContentHeaderPathNormativitiesInfoWidgets() {
    const navigate = useNavigate()
    const [windowIsSmall, setWindowIsSmall] = useState(false);
    const { searchLineIsShown } = useAppSelector(state => state.contentHeader)
    const sideBarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setWindowIsSmall(contentHeaderWidth < 720)
    }, [sideBarIsShown, navigate])

    const widgetsConfigArray = [
        {
            active: searchLineIsShown,
            name: "Поиск",
            imageSrc: searchLineButtonIconSrc,
            onClick: controlSearchLineButton
        },
        {
            visible: windowIsSmall,
            name: "Настройки фильтров ненормативных участков",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlPathNormativitiesInfoFilterButton(navigate)
        }
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                        />
                    )
                }
            })}
        </>
    )
}